import {create} from "zustand";

export const useStore = create((set) => ({
    account: null,
    setAccount: () => set((updatedAccount: any) => ({account: updatedAccount})),
}))

export default useStore;